import { render, staticRenderFns } from "./DraggableListProducts.vue?vue&type=template&id=79da1790"
import script from "./DraggableListProducts.vue?vue&type=script&lang=js"
export * from "./DraggableListProducts.vue?vue&type=script&lang=js"
import style0 from "./DraggableListProducts.vue?vue&type=style&index=0&id=79da1790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports